import { render, staticRenderFns } from "./customer-repayment-schedule-kh.vue?vue&type=template&id=b95e4178&scoped=true&"
import script from "./customer-repayment-schedule-kh.vue?vue&type=script&lang=js&"
export * from "./customer-repayment-schedule-kh.vue?vue&type=script&lang=js&"
import style0 from "./customer-repayment-schedule-kh.vue?vue&type=style&index=0&id=b95e4178&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b95e4178",
  null
  
)

export default component.exports